module.exports = __webpack_public_path__ + "static/media/oops_icon.f81ee0b5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/flavours/bubble/images/oops_icon.svg
// module id = 631
// module chunks = 0